import Vue from 'vue';
import store from '@/store/index';

Vue.directive('load-more', {
  bind(el, binding) {
    const wrap = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
    if(wrap) {
      wrap.addEventListener('scroll', function() {
        if (this.scrollHeight - this.scrollTop - this.clientHeight <= 3) {
          binding.value();
        }
      })
    }
  }
})

Vue.directive('has', {
  inserted: function (el, binding) {
      if (!Vue.prototype.$_has(binding.value)) {
        // el.disabled = 'disabled';
        // el.classList.add('is-disabled');
        // el.classList.add('forbiddenBtn');
        if (el.nextElementSibling && el.nextElementSibling.className.includes('el-divider')) {
          el.parentNode.removeChild(el.nextElementSibling);
        }
        if(el.parentNode && el.parentNode.className.includes('el-tabs__item')) {
          el.parentNode.parentNode.removeChild(el.parentNode);
        } else {
          el.parentNode.removeChild(el);
        }
      }
  }
})

Vue.directive('resize', {
  bind(el, binding) {
    let width = '', height = '';
    function isReize() {
      const style = document.defaultView.getComputedStyle(el);
      if (width !== style.width || height !== style.height) {
        binding.value();
      }
      width = style.width;
      height = style.height;
    }
    el.__vueSetInterval__ = setInterval(isReize, 300);
  },
  unbind(el) {
    clearInterval(el.__vueSetInterval__);
  }
})

Vue.prototype.$_has = function(value) {
  let btnPermisstions = store.state.base.roleIds;
  const isCustomer = store.state.base.identity === 'consumer';
  if (!isCustomer) {
    if (!Array.isArray(btnPermisstions)) {
      return false;
    }
    if (!value) {
      return true;
    }
    if (Array.isArray(value) && btnPermisstions.some(permission => value.includes(permission))) {
      return true;
    }
    return false;
  } else return true;
}

export {
  has
}


// WEBPACK FOOTER //
// ./src/utils/directives.js